import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import { getProduct } from "../../api";

const ProductDetail = () => {
  const { category, productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      (async () => {
        const res = await getProduct({ id: productId });
        const data = res.data;
        setProduct(data);
      })();
      setLoading(false);
    }, 100);
  }, [category, productId, navigate]);

  if (loading) {
    return <div className="loading">로딩 중...</div>;
  }

  if (!product) {
    return <div className="not-found">제품을 찾을 수 없습니다.</div>;
  }

  return (
    <div className="product-detail-container">
      <div className="product-detail-content">
        <h1 className="product-title">{product.name}</h1>
        {product.subtitle && <h2 className="product-subtitle">{product.subtitle}</h2>}
        <div className="product-info-grid">
          <div className="product-specs">
            <table className="specs-table">
              <tbody>
                <tr key="제품">
                  <th>제품</th>
                  <td>{product.title}</td>
                </tr>
                <tr key="카테고리">
                  <th>카테고리</th>
                  <td>{product.category.name}</td>
                </tr>
                <tr key="용량">
                  <th>용량</th>
                  <td>{product.capacity}</td>
                </tr>
                <tr key="제조">
                  <th>제조</th>
                  <td>{product.manufacture}</td>
                </tr>
                <tr key="제조사">
                  <th>제조사</th>
                  <td>{product.manufacturer}</td>
                </tr>
                <tr>
                  <th>내용</th>
                  <td dangerouslySetInnerHTML={{ __html: product.content }}></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="product-image-container">
          {product.product_img ? <img src={product.product_img[0].file.url} alt={product.name} className="product-detail-image" /> : <div className="placeholder-image">이미지 준비 중</div>}
        </div>
        <div className="product-list-button-container">
          <button className="product-list-button" onClick={() => navigate(`/products/${category}`)}>
            목록으로
            <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="74.318" height="9.143" viewBox="0 0 74.318 9.143">
              <path data-name="패스 17" d="M7734.385 1613.134h72.855l-10.653-8.248" transform="translate(-7734.385 -1604.491)" style={{ fill: "none", stroke: "currentColor" }} />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
